import React, { Fragment } from 'react';
const HOTMART = 'https://pay.hotmart.com/O103704589E';
const PRODUCT_IMG = 'https://cdn.magicpatterns.com/uploads/gvkgUj7q9QwxHEt8wA7Vkh/ChatGPT_Image_23_feb_2026,_10_54_32.png';
const BG_IMG = 'https://cdn.magicpatterns.com/uploads/bF9FQNBjLgbPnbbV6rox77/WhatsApp_Image_2026-02-23_at_12.46.49.jpg';
export function HeroSection() {
  return <section className="pt-10 pb-16 md:pt-16 md:pb-28 px-4 overflow-hidden relative" data-id="element-185">
      {/* Background image — full, atenuada */}
      <div className="absolute inset-0 bg-cover bg-center bg-no-repeat" style={{
      backgroundImage: `url(${BG_IMG})`,
      opacity: 0.22
    }} data-id="element-186"></div>
      {/* Overlay cálido más transparente para que se vea la imagen */}
      <div className="absolute inset-0 bg-[#f5ede0]/72" data-id="element-187"></div>

      {/* Glows */}
      <div className="absolute inset-0 pointer-events-none" data-id="element-188">
        <div className="absolute top-1/3 left-1/2 -translate-x-1/2 w-[600px] h-[600px] bg-[#d4a017]/8 rounded-full blur-[120px]" data-id="element-189"></div>
        <div className="absolute bottom-0 right-1/4 w-[300px] h-[300px] bg-[#7aaa8a]/8 rounded-full blur-[100px]" data-id="element-190"></div>
      </div>

      <div className="container mx-auto max-w-3xl text-center relative z-10" data-id="element-191">
        {/* Eyebrow */}
        <div className="animate-in flex flex-col items-center gap-3 mb-7" data-id="element-192">
          <div className="flex items-center gap-3 w-full max-w-xs sm:max-w-sm" data-id="element-193">
            <span className="flex-1 h-px bg-gradient-to-r from-transparent to-[#7aaa8a]/40" data-id="element-194"></span>
            <span className="w-1.5 h-1.5 rounded-full bg-[#7aaa8a]/50" data-id="element-195"></span>
            <span className="flex-1 h-px bg-gradient-to-l from-transparent to-[#7aaa8a]/40" data-id="element-196"></span>
          </div>
          <div className="flex flex-wrap items-center justify-center gap-x-4 gap-y-2" data-id="element-197">
            {['Aprendé', 'Armonizá', 'Saná', 'Despertá', 'Ayudá'].map((word, i) => <Fragment key={word} data-id="element-198">
                  <span className="text-[#5a8a6a] font-semibold tracking-[0.28em] uppercase text-xs sm:text-sm" style={{
              fontFamily: "'Cormorant Garamond', serif"
            }} data-id="element-199">
                    {word}
                  </span>
                  {i < 4 && <span className="text-[#7aaa8a]/40 text-base leading-none select-none" data-id="element-200">
                      ·
                    </span>}
                </Fragment>)}
          </div>
          <div className="flex items-center gap-3 w-full max-w-xs sm:max-w-sm" data-id="element-201">
            <span className="flex-1 h-px bg-gradient-to-r from-transparent to-[#7aaa8a]/40" data-id="element-202"></span>
            <span className="w-1.5 h-1.5 rounded-full bg-[#7aaa8a]/50" data-id="element-203"></span>
            <span className="flex-1 h-px bg-gradient-to-l from-transparent to-[#7aaa8a]/40" data-id="element-204"></span>
          </div>
        </div>

        {/* Headline */}
        <h1 className="animate-in delay-100 mb-8" data-id="element-205">
          <span className="block text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-serif font-bold tracking-tight leading-[1.05] mb-2" style={{
          textShadow: '2px 2px 0px rgba(42,31,14,0.12), 4px 4px 0px rgba(42,31,14,0.06)'
        }} data-id="element-206">
            <span className="text-[#2a1f0e]" data-id="element-207">Curso Integral de </span>
            <span className="relative inline-block" data-id="element-208">
              <span className="relative z-10 text-transparent bg-clip-text bg-gradient-to-r from-[#b8860b] via-[#e8c44a] to-[#b8860b]" data-id="element-209">
                Reiki
              </span>
              <span className="absolute -inset-2 bg-gradient-to-r from-[#d4a017]/20 via-[#f0c040]/25 to-[#d4a017]/20 blur-xl rounded-xl -z-0" data-id="element-210"></span>
            </span>
          </span>
          <span className="block text-xl sm:text-2xl md:text-3xl lg:text-4xl font-serif italic font-light tracking-wide px-2 mt-1" style={{
          textShadow: '1px 1px 0px rgba(100,80,160,0.25), 3px 3px 0px rgba(100,80,160,0.12)'
        }} data-id="element-211">
            <span className="text-[#7c5cbf]" data-id="element-212">
              Sana Tu Vida y Conviértelo en Tu Próxima Salida Laboral
            </span>
          </span>
        </h1>

        {/* Product Image — animated float */}
        <a href="#pricing" className="animate-scale-in delay-300 block mx-auto max-w-xs sm:max-w-md md:max-w-lg mb-6 cursor-pointer" data-id="element-213">
          <div className="relative animate-float" data-id="element-214">
            <div className="absolute -inset-4 md:-inset-6 bg-gradient-to-br from-[#d4a017]/30 via-[#f0c040]/15 to-[#7aaa8a]/15 rounded-3xl blur-3xl opacity-80" data-id="element-215"></div>
            <div className="relative p-1 rounded-2xl bg-gradient-to-br from-[#d4a017]/40 via-[#f5ede0]/20 to-[#d4a017]/30 shadow-[0_12px_60px_rgba(184,134,11,0.3)]" data-id="element-216">
              <div className="rounded-xl overflow-hidden" data-id="element-217">
                <img src={PRODUCT_IMG} alt="Curso Integral de Reiki - Formación Completa" className="w-full object-cover block" data-id="element-218" />
              </div>
            </div>
          </div>
        </a>

        {/* Subheadline — debajo del mockup */}
        <p className="animate-in delay-400 text-[#3a2a10] mb-8 max-w-xl mx-auto leading-relaxed px-2" style={{
        fontFamily: "'Cormorant Garamond', serif",
        fontSize: '1.15rem',
        fontWeight: 500
      }} data-id="element-219">
          Aprende Reiki desde cero con un método estructurado que te permite
          sanar profundamente y formarte para ofrecer sesiones profesionales.
        </p>

        {/* CTA */}
        <a href="#pricing" className="animate-in delay-500 cta-btn inline-block px-6 sm:px-10 md:px-12 py-4 md:py-5 rounded-full text-white font-bold text-base sm:text-lg md:text-xl tracking-widest uppercase mb-5 transition-all w-full sm:w-auto max-w-sm sm:max-w-none" style={{
        fontFamily: "'Cormorant Garamond', serif",
        letterSpacing: '0.1em',
        background: 'linear-gradient(135deg, #1a6b3a 0%, #2d9a55 50%, #1a6b3a 100%)',
        boxShadow: '0 0 35px rgba(29,107,58,0.45), inset 0 1px 0 rgba(255,255,255,0.15)'
      }} data-id="element-220">
          ✨ QUIERO FORMARME EN REIKI AHORA 🌿
        </a>

        <p className="animate-fade delay-700 text-[#5c4a2a]/60 text-xs tracking-[0.15em] uppercase" style={{
        fontFamily: "'Cormorant Garamond', serif"
      }} data-id="element-221">
          Acceso 100% digital · Paso a paso · Sin experiencia previa necesaria
        </p>
      </div>
    </section>;
}